import { TNewOrderCountry } from "@/entities/new-order";

//Возвращает массив дат из объекта страны
export const getDatesListFromCountry = (
  country: TNewOrderCountry,
): string[] => {
  if (!country?.keywords || typeof country.keywords !== "object") {
    return [];
  }
  return Object.keys(country.keywords);
};
